import { render } from "./Galeria.vue?vue&type=template&id=6a368888"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"
script.render = render

export default script